// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__32Bku","productName":"Table_productName__GECnG"};